import './FunctionPart.scss'

import React, { FunctionComponent, useState } from 'react'
import { Collapse } from 'react-collapse'
import useWindowDimensions from 'Root/Shared/utils/useWindowDimensions'
import PuxMediaSelector, {
  PuxMediaSelectorType,
} from 'Shared/components/content/mediaImage/PuxMediaSelector'
import PuxVideo, { PuxVideoType } from 'Shared/components/PuxVideo/PuxVideo'
import PuxWysiwyg, {
  PuxWysiwygHtmlBodyType,
} from 'Shared/components/PuxWysiwyg/PuxWysiwyg'
import { t } from 'ttag'

import PuxLightboxGallery from '../../PuxLightboxGallery/PuxLightboxGallery'
import PuxLink from 'Root/Shared/utils/PuxLink'
import { useEditorStatus } from 'Root/Shared/utils/edit/useEditorStatus'
import { getLocalizedUrl } from 'Root/Shared/utils/localeURL'
import PuxIcon from '../../PuxIcon/PuxIcon'
import EasyDynamicEight, {
  EasyDynamicEightType,
} from '../../EasyDynamicEight/EasyDynamicEight'

export interface FunctionPartType {
  contentType: 'EasySoftwareFunction'
  contentItemId: string
  path: string
  displayText: string
  functionPerex: PuxWysiwygHtmlBodyType
  functionContent: PuxWysiwygHtmlBodyType
  functionImage: PuxMediaSelectorType
  functionGallery: PuxMediaSelectorType
  puxVideo: PuxVideoType
  functionShowMoreLabel: PuxWysiwygHtmlBodyType
  functionOpenDetail: boolean
  easyDynamicEight?: EasyDynamicEightType
}

const FunctionPart: FunctionComponent<FunctionPartType> = (props) => {
  const [isOpened, setIsOpened] = useState(false)
  const { width } = useWindowDimensions()
  const isEditor = useEditorStatus()
  const dynamicEightEnabled =
    props.easyDynamicEight?.dynamicEightEnabled === true

  const ImageContentGallery = (
    <PuxLightboxGallery
      {...props.functionGallery}
      disableLazyload
      width={160}
      height={80}
    />
  )

  const thumbnail =
    props.puxVideo?.videoThumbnail?.resizePaths?.length > 0
      ? props.puxVideo?.videoThumbnail
      : props.functionImage.mediaSelectorImage
  return (
    <div
      className={`Function${
        dynamicEightEnabled ? ` Function--dynamicEight` : ``
      }`}
    >
      <div className='Function-image'>
        <div className='Function-mainImage'>
          {dynamicEightEnabled && (
            <EasyDynamicEight
              {...props.easyDynamicEight}
              dynamicEightFit='width'
              dynamicEightHeight='100%'
            />
          )}
          {!props.puxVideo?.videoYTID?.html && (
            <PuxMediaSelector
              {...props.functionImage}
              width={720}
              height={400}
            />
          )}
          {props.puxVideo?.videoYTID?.html && (
            <PuxVideo
              videoStructuredDataContentUrl={
                props.puxVideo?.videoStructuredDataContentUrl
              }
              videoStructuredDataDescription={
                props.puxVideo?.videoStructuredDataDescription
              }
              videoStructuredDataName={props.puxVideo?.videoStructuredDataName}
              videoStructuredDataUploadDate={
                props.puxVideo?.videoStructuredDataUploadDate
              }
              videoThumbnail={thumbnail}
              videoYTID={props.puxVideo?.videoYTID}
            />
          )}
          {!dynamicEightEnabled && width > 767 && (
            <Collapse isOpened={isOpened}>{ImageContentGallery}</Collapse>
          )}
        </div>
        {dynamicEightEnabled && width > 767 && (
          <Collapse isOpened={isOpened}>{ImageContentGallery}</Collapse>
        )}
      </div>
      <div className='Function-content'>
        {isEditor ? (
          <>
            <PuxLink to={`${getLocalizedUrl(props.path)}`}>
              <h3>{props.displayText ? props.displayText : `Edit`}</h3>
            </PuxLink>
            <PuxWysiwyg wysiwygId={props.contentItemId} content={props.functionPerex} />
          </>
        ) : (
          <>
            {props.displayText && (<h3>{props.displayText}</h3>)}
            <PuxWysiwyg wysiwygId={props.contentItemId} content={props.functionPerex} />
          </>
        )}
        {props.functionOpenDetail ?
          <div className={`Function-openDetail`}>
            <PuxLink className='Button Button--underline Button--md' to={`${getLocalizedUrl(props.path)}`}>
              {`${props.functionShowMoreLabel.html}`}<PuxIcon
                    name={`arrows/arrow-right`}
                    size={16}
                    decorative
                  />
            </PuxLink>
          </div>
          :
          (props.functionContent?.html ||
            props.functionGallery?.mediaSelectorImage?.resizePaths[0]) && (
            <>
              <Collapse
                initialStyle={{ height: `0px`, overflow: `hidden` }}
                isOpened={isOpened}
              >
                {props.functionContent?.html && (
                  <PuxWysiwyg wysiwygId={props.contentItemId} content={props.functionContent} />
                )}
                {width < 768 && ImageContentGallery}
              </Collapse>
              <div className={`Function-moreLess`}>
                <button
                  className='Button Button--underline Button--md'
                  onClick={() => setIsOpened(!isOpened)}
                >
                  {isOpened
                    ? t`Redmine.Function.LessInfo`
                    : t`Redmine.Function.MoreInfo`}
                  <PuxIcon
                    name={
                      isOpened
                        ? `user-interface/e-delete`
                        : `user-interface/e-add`
                    }
                    size={16}
                    decorative
                  />
                </button>
              </div>
            </>
          )
        }
      </div>
    </div>
  )
}

export default FunctionPart
